import { c as _c } from "react/compiler-runtime";
import type { ProjectStatus } from "@agroproj/backend/convex/types";
import { CheckCircle, Clock, type LucideIcon, XCircle } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { projectStatusEnum } from "@/data/entity-types";
const projectStatusConfig: Record<ProjectStatus, {
  icon: LucideIcon;
  variant: "status-open" | "status-completed" | "status-canceled";
}> = {
  open: {
    icon: Clock,
    variant: "status-open"
  },
  completed: {
    icon: CheckCircle,
    variant: "status-completed"
  },
  canceled: {
    icon: XCircle,
    variant: "status-canceled"
  }
};

/** Project lifecycle badge. The only place that maps a project status to its label and color. */
export function ProjectStatusBadge(t0) {
  const $ = _c(6);
  const {
    status
  } = t0;
  const {
    icon: Icon,
    variant
  } = projectStatusConfig[status];
  let t1;
  if ($[0] !== Icon) {
    t1 = <Icon data-icon="inline-start" />;
    $[0] = Icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = projectStatusEnum[status];
  let t3;
  if ($[2] !== t1 || $[3] !== t2 || $[4] !== variant) {
    t3 = <Badge variant={variant}>{t1}{t2}</Badge>;
    $[2] = t1;
    $[3] = t2;
    $[4] = variant;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}